import React from 'react';
import styled from '@emotion/styled';

import { QuoteWaveIcon } from '../Icons';
import { QuoteImage } from './QuoteImage';
import { IMAGE_MAP } from './constants';
import { SCREEN_BREAKPOINTS } from '../../constants';

const Container = styled.div`
  position: relative;
  display: grid;
  align-content: center;
  width: 100%;
  height: 438px;
  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    height: 438px;
  }

  @media (max-width: 900px) {
    height: 300px;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    height: 200px;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    height: 150px;
  }

  svg {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1300px;
  margin: auto;
  padding: 0 24px;
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    padding: 0;
  }
`;

export const QuoteImagesBlock = () => {
  return (
    <Container>
      <ImageContainer>
        <QuoteImage image={IMAGE_MAP.imageOne} />
        <QuoteImage image={IMAGE_MAP.imageTwo} />
        <QuoteImage image={IMAGE_MAP.imageThree} />
      </ImageContainer>
      <QuoteWaveIcon />
    </Container>
  );
};
